<template>
  <div class="flex flex-align-items-center flex-center header-border">
    <div class="my-120 pt-0" style="width: 336px;">
      <vz-auth-form />
    </div>
  </div>
</template>

<script setup lang="ts">
import VzAuthForm from '~/components/forms/auth/vz-auth-form.vue';
import {storeToRefs} from 'pinia';
import {useUserStore} from '~/stores/personal/user';

const { token } = storeToRefs(useUserStore())

onBeforeMount(() => {
  if (token.value) {
    navigateTo('/personal/orders/')
  }
})
</script>

<style lang="scss">
.header-border {
  border-top: 1px solid $border-gray;
}
</style>
